import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isTermsOpen, setIsTermsOpen] = useState(false);

  const handleCloseDrawer = () => {
    setDrawerOpen(false);
    setIsTermsOpen(false);
  };

  console.log(drawerOpen, "drawerOpen");

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const dropdownRef = useRef(null);

  return (
    <>
      {/*===== PROGRESS STARTS=======*/}
      <div className="paginacontainer">
        <div className="progress-wrap">
          <svg
            className="progress-circle svg-content"
            width="100%"
            height="100%"
            viewBox="-1 -1 102 102"
          >
            <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
          </svg>
        </div>
      </div>
      {/*===== PROGRESS ENDS=======*/}

      {/*=====HEADER START=======*/}
      <header className="homepage1-body">
        <div
          id="vl-header-sticky"
          className="vl-header-area vl-transparent-header shadow-sm"
        >
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-3 col-md-6 col-6">
                <div className="flex items-center space-x-3">
                  <img
                    src="assets/img/favicon.png"
                    alt="Logo"
                    className="sm:w-[2.5rem] max-md:w-[40px]"
                  />
                  <div className="flex items-baseline space-x-1">
                    <span className="text-xl sm:text-2xl font-bold text-black">
                      Preventive
                    </span>
                    <span className="text-xl sm:text-2xl font-bold text-[#5b21b6]">
                      Pulse
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-lg-5 d-none d-lg-block">
                <div className="vl-main-menu text-center">
                  <nav className="vl-mobile-menu-active">
                    <ul>
                      <li>
                        <Link to="/">Home</Link>
                      </li>
                      <li>
                        <Link to="/about-us">About Us</Link>
                      </li>
                      <li className="has-dropdown">
                        <Link>
                          Plans
                          <span className="arrow-size ml-2">
                            <i className="fa-solid fa-angle-down d-lg-inline d-none" />
                          </span>
                        </Link>
                        <ul className="sub-menu">
                          <li>
                            <Link to="/preventivepulseprime">Preventive Pulse Prime</Link>
                          </li>
                          <li>
                            <Link to="/preventivepulseadvantage">Preventive Pulse Advantage</Link>
                          </li>
                          <li>
                            <Link to="/preventivepulsepremiumcare">Preventive Pulse Premium Care</Link>
                          </li>
                          <li>
                            <Link to="/preventivepulsehealthshield">
                              Preventive Pulse Health Shield
                            </Link>
                          </li>
                          <li>
                            <Link to="/preventivepulsehealthshieldplus">
                              Preventive Pulse Health Shield Plus
                            </Link>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <Link to="/contact">Contact Us</Link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-6">
                <div className="d-none d-lg-block text-right">
                  <a href="/login.html" target="_blank">
                    <button class="frutiger-button">
                      <div class="inner">
                        <div class="top-white"></div>
                        <span class="text">Sign Into App</span>
                      </div>
                    </button>
                  </a>
                </div>
                <div className="vl-header-action-item d-block d-lg-none">
                  <button
                    type="button"
                    onClick={() => {
                      setDrawerOpen(!drawerOpen);
                    }}
                    className="vl-offcanvas-toggle"
                  >
                    <i className="fa-solid fa-bars-staggered" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      {/*=====HEADER END =======*/}
      {/*===== MOBILE HEADER STARTS =======*/}
      <div className="homepage1-body">
        {drawerOpen && (
          <div className="vl-offcanvas vl-offcanvas-open bg-gradient-to-r from-[#190538] to-[#190538]">
            <div className="vl-offcanvas-wrapper">
              <div className="vl-offcanvas-header d-flex justify-content-between align-items-center mb-0">
                <div className="vl-offcanvas-logo">
                </div>
                <div className="vl-offcanvas-close">
                  <button
                    className="vl-offcanvas-close-toggle"
                    onClick={handleCloseDrawer}
                  >
                    <i className="fa-solid fa-xmark" />
                  </button>
                </div>
              </div>
              <div className="vl-offcanvas-menu d-lg-none mb-40">
                <nav className="vl-mobile-menu-active">
                  <ul>
                    <li>
                      <Link to="/" onClick={handleCloseDrawer}>Home</Link>
                    </li>
                    <li>
                      <Link to="/about-us" onClick={handleCloseDrawer}>About Us</Link>
                    </li>
                    <li>
                      <Link className="!flex w-full justify-between items-center gap-2" onClick={() => setIsTermsOpen(!isTermsOpen)}>
                        Plans
                        <span className="arrow-size ml-2">
                          <i className={`fa-solid fa-angle-down text-white ${isTermsOpen ? 'rotate-180 transition-all' : 'transition-all'}`} />
                        </span>
                      </Link>
                      {isTermsOpen && (
                        <ul className="bg-[#331463] px-4 py-2 my-2 rounded-lg">
                          <li>
                            <Link to="/preventivepulseprime" onClick={handleCloseDrawer}>Preventive Pulse Prime</Link>
                          </li>
                          <li>
                            <Link to="/preventivepulseadvantage" onClick={handleCloseDrawer}>Preventive Pulse Advantage</Link>
                          </li>
                          <li>
                            <Link to="/preventivepulsepremiumcare" onClick={handleCloseDrawer}>Preventive Pulse Premium Care</Link>
                          </li>
                          <li>
                            <Link to="/preventivepulsehealthshield" onClick={handleCloseDrawer}>Preventive Pulse Health Shield</Link>
                          </li>
                          <li>
                            <Link to="/preventivepulsehealthshieldplus" onClick={handleCloseDrawer}>Preventive Pulse Health Shield Plus</Link>
                          </li>
                        </ul>
                      )}
                    </li>

                    <li>
                      <Link to="/contact" onClick={handleCloseDrawer}>Contact Us</Link>
                    </li>

                    <li>
                      <a href="/login.html" target="_blank">Login App</a>
                    </li>
                  </ul>
                </nav>
              </div>
              <div className="space20" />
              <div className="vl-offcanvas-info">
                <h3 className="vl-offcanvas-sm-title">Contact Us</h3>
                <div className="space20" />
                <span>
                  <a href="tel:+91 9899761818">
                    <i className="fa-regular fa-envelope" /> +91 989-976-1818
                  </a>
                </span>
                <span>
                  <a href="mailto:support@preventivepulse.in">
                    <i className="fa-solid fa-phone" />
                    support@preventivepulse.in
                  </a>
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
      {/*===== MOBILE HEADER STARTS =======*/}
    </>
  );
};

export default Header;
